export const ActivityIndicator = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      style={{ width: size, height: size }}
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
    >
      <circle opacity="0.15" cx="8" cy="8" r="7" fill="#4A67FB" />
      <path
        d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
        fill="#4A67FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
        fill="#4A67FB"
      />
    </svg>
  );
};
